/**
 * The app shell's door while a HubSpot-path sign-up is pending its trial.
 *
 * On that path the account exists before the card, so a person who leaves
 * the paywall and comes back would otherwise land on a working dashboard.
 * While the standing is unknown nothing is drawn, so the dashboard never
 * flashes before the turn; while pending the person is sent to the report,
 * which shows the fix and the one next step. Two settings pages stay open:
 * nobody is ever trapped away from their billing or from deleting the
 * account. Everything outside the shell (the welcome pages, HubSpot connect,
 * checkout, marketing) is not behind this at all.
 */
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { buildStandingReturnPath, useOnboardingStanding } from '@/hooks/useOnboardingStanding'

export const OPEN_WHILE_PENDING = ['/settings/account', '/settings/billing']

export function isOpenWhilePending(pathname: string): boolean {
  return OPEN_WHILE_PENDING.some((path) => pathname === path || pathname.startsWith(`${path}/`))
}

export function OnboardingStandingGate({ children }: { children: ReactNode }) {
  const { standing, isLoading } = useOnboardingStanding()
  const { pathname } = useLocation()
  if (isOpenWhilePending(pathname)) return <>{children}</>
  if (isLoading) return null
  if (standing.pending) return <Navigate to={buildStandingReturnPath(standing)} replace />
  return <>{children}</>
}

export default OnboardingStandingGate
